import React from 'react'

import CopyToClipboard from '@src/components/CopyToClipboard'
import UpArrowCorner from '@src/components/icons/UpArrowCorner'
import { getBlockExplorerUrlFromChainId } from '@src/utils/getBlockExplorerUrl'
import { truncateAddress } from '@src/utils/truncateAddress'

export interface DestinationTxComponentProps {
    destinationTxHash?: string
    chainId?: string | number
}

export const DestinationTxComponent: React.FC<DestinationTxComponentProps> = ({ destinationTxHash, chainId }) => {
    // Extract the transaction hash from the full URL if it's a URL
    const txHashOnly = destinationTxHash?.includes('/')
        ? destinationTxHash.substring(destinationTxHash.lastIndexOf('/') + 1)
        : destinationTxHash

    const formattedDestinationTxHash = txHashOnly && truncateAddress(txHashOnly)

    // Generate the block explorer URL if we have a chainId
    const blockExplorerUrl =
        chainId && txHashOnly ? `${getBlockExplorerUrlFromChainId(chainId)}/${txHashOnly}` : destinationTxHash // Fallback to the original URL if we don't have chainId

    return (
        <div className='flex items-center justify-between'>
            <span className='text-sm text-mach-sub-text'>Destination Id</span>
            <div className='flex items-center gap-[6px]'>
                <CopyToClipboard anchorId='dest-tx-hash' textToCopy={txHashOnly || ''} />
                <span className='text-sm'>{formattedDestinationTxHash}</span>
                <a
                    className='flex cursor-pointer text-mach-sub-text'
                    href={blockExplorerUrl}
                    target='_blank'
                    rel='noreferrer'
                >
                    <UpArrowCorner className='h-3 w-3' />
                </a>
            </div>
        </div>
    )
}
